import React, {
  PropTypes,
  Component
} from 'react';
import './style.less';
import mobx from 'mobx';

import Icon from '../Icon';

export default class CheckSwitchButton extends Component {
  state = {}

  constructor(props) {
    super(props);
    this.state.checked = this.parseValue(props.value);
  }

  parseValue(value) {
    if (typeof value == 'string') {
      return value == 'true' || value == 'True' || value == '1';
    } else {
      return !!value;
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      checked: this.parseValue(nextProps.value)
    });
  }

  handleChange = (e) => {
    e.preventDefault();
    this.setState({
      checked: !this.state.checked
    });
    if (this.props.onChange) {
      // this.props.onChange(!this.state.checked);
      this.props.onChange({value:!this.state.checked, text:(!this.state.checked).toString()});
    }
  }

  render() {
    const {
      name
    } = this.props;
    return (
      <div className='buttonGroup' onClick={this.handleChange}>
        <Icon type={this.state.checked?'fuxuan':'weixuan'} className='checkicon'/>
        <span>{name}</span>
      </div>
    )
  }

}
